const PRODUCT_IMAGE_BASE_URL = 'PRODUCT_IMAGE_BASE_URL';

/**
 * Resolve a product storage key against the public, read-only image origin.
 *
 * Only the public base URL is exposed to the browser. S3/MinIO credentials
 * remain outside the frontend bundle and are used exclusively by the
 * migration/operations path.
 */
export function productImageUrl(imageKey: string, baseUrl: string): string {
	const key = String(imageKey || '').trim();
	const base = String(baseUrl || '').trim().replace(/\/+$/, '');

	if (!base) {
		throw new Error(`${PRODUCT_IMAGE_BASE_URL} is required to render product images.`);
	}

	if (/^https?:\/\//i.test(key)) {
		throw new Error('Product image data must contain a storage object key, not a source URL.');
	}

	const encodedKey = key
		.split('/')
		.filter(Boolean)
		.map((segment) => encodeURIComponent(segment))
		.join('/');

	if (!encodedKey) {
		throw new Error('Product image storage key is required.');
	}

	return `${base}/${encodedKey}`;
}
